import * as React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import ChooseActivityTemplate from "../ChooseActivityTemplate";
import ReopenActList from "./ReopenActList";
import LoaderComponent from "../Loader";
import {  getActivityListByClaim } from '../../containers/WorkkardDetail/actions/action';
import { useModules } from '../../utils/modules';

class ActOptionForReopenWk extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedActOption: "",
            isCreateNewActivity: false,
            isReopenActivity: false,
            actOptionArr: []

        }
    }

    componentDidMount() {
        const activityListingPayload = {
            skip: "0",
            take: "50",
            cId: this.props.wkid,
            isForReopenWk: true
        };

        this.props.getActivityListByClaim(activityListingPayload);

    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.activitiesData.hasOwnProperty("showReopenActivityOption") && prevProps.activitiesData != this.props.activitiesData) {
            let optionArr = [];
            if (this.props.uView?.permissions?.can_create_activity && useModules().isModuleEnabled("workkards.reopen_workkard.create_activity")) {
                optionArr.push({ name: "CreateActOption", id: "CreateActOption", label: "Create Activity" });
            }
            if (this.props.uView?.permissions?.can_reopen_activity && this.props.activitiesData.showReopenActivityOption && useModules().isModuleEnabled("workkards.reopen_workkard.reopen_activity")) {
                optionArr.push({ name: "ReopenActOption", id: "ReopenActOption", label: "Reopen Activity" });
            }
            this.setState({ actOptionArr: optionArr });
        }
    }



    render() {

        return (
            <React.Fragment>
                <div className="activityTemplate col-3 mb">
                    <p className="rowFlex alignMiddle">
                        <label>Please select an option that you want to choose to reopen this Workkard</label>
                    </p>
                    {this.state.actOptionArr.length > 0 ?

                        <ul className="wrapFlex">
                            {this.state.actOptionArr.map((item, key) => {
                                return (
                                    <li key={key}>
                                        <input type="radio" name={item.name} className="gap" id={item.id} checked={this.state.selectedActOption == item.id ? true : false} onChange={(e) => { this.setState({ selectedActOption: e.target.id }) }} />
                                        <label htmlFor={item.name}>{item.label}</label>
                                    </li>
                                )
                            })
                            }
                        </ul> :
                        <LoaderComponent />}
                </div>

                {this.state.selectedActOption != "" ? this.renderSelectedOption(this.state.selectedActOption) : null}
            </React.Fragment>
        )

    }

    renderSelectedOption(option) {

        return (
            <div >
                {option == "CreateActOption" ? this.createActivity() : this.reopenActivity()}
            </div>)
    }

    createActivity() {
        if (this.state.isReopenActivity) {
            this.props.resetActivity();
            this.setState({ isReopenActivity: false });
        }
        return [
            <label class="mt__1">Please select an Activity template</label>,
            <ChooseActivityTemplate showReason={this.props.showReason} modalBodyClass="inner_container_area" setActivity={(selectedActiviy) => { this.props.setActivity(selectedActiviy); this.setState({ isCreateNewActivity: true }); }} />
        ]
    }

    reopenActivity() {
        if (this.state.isCreateNewActivity) {
            this.props.resetActivity();
            this.setState({ isCreateNewActivity: false });
        }
        return [
            <ReopenActList reopenActlist={this.props.activitiesData.closeActivities} setReOpenActivity={(data) => { this.props.setReOpenActivity(data); this.setState({ isReopenActivity: true }) }} />]
    }

}

const mapStateToProps = (state) => ({
    activitiesData: state.workkardDetail.activityListing
});

const mapDispatchToProps = (dispatch) => ({
    getActivityListByClaim: bindActionCreators(getActivityListByClaim, dispatch)
});


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ActOptionForReopenWk);

